export default {
  methods: {
    getRegexFriendlyString (str, append) {
      if (!str) {
        return ''
      }
      return str.replace(/\W/g, '').toUpperCase() + (append || '')
    },
    getRandomId () {
      return this.randomString().toUpperCase()
    }
  }
}
